import A from 'utils/metrics/analytic'

enum buttonsUnauth {
  CLINCASE = 'clincase',
  LIBRARY = 'library',
  AIBOLIT = 'aibolit',
  SHARE = ' clincase_share',
  WEBINARS = 'webinars',
}
// Скролл главной страницы
const A_MU_SCROLL = 'intro_scroll'

// Нажатия на кнопки на странице для незареганного
const A_mu_buttons = (name: buttonsUnauth) => {
  A.setEvent('intro_click_buttons', { name })
}

export { A_MU_SCROLL, A_mu_buttons, buttonsUnauth }
